/**
 * External dependencies
 */
import { useMemo } from 'react';
import Theme from '@naruto/naruto-theme/src';
import { ThemeOptions } from '@naruto/naruto-theme/src/types';
import { deepmerge } from '@mui/utils';

/**
 * Internal dependencies
 */
import { ThemeLocalConfig, ThemeLocalKeys } from '@naruto/bgdapp/src/base/theme';
import useMappedState from '@naruto/bgdapp/src/hooks/useMappedState';

/**
 * 描述 : 取得客製化主題
 */
export default function useTheme(options: ThemeOptions = {}): ThemeOptions {
  /* Global & Local State */
  const storeGlobal = useMappedState(state => state.global);

  /* Data */
  const themeInstance = useMemo(() => new Theme(ThemeLocalConfig), []);

  /* Main */
  return useMemo(() => {
    const fontScaleOptions: ThemeOptions = {
      typography: {
        htmlFontSize: 16
      },
      components: {
        MuiCssBaseline: {
          styleOverrides: {
            html: {
              fontSize: `${storeGlobal.globalFontScale * 100}%`,
              transition: 'font-size 0.3s ease-in-out'
            }
          }
        }
      }
    };

    const finalOptions = deepmerge(options, fontScaleOptions);

    return themeInstance.createTheme(ThemeLocalKeys.DEFAULT, finalOptions);
  }, [storeGlobal.globalThemeVersion, storeGlobal.globalFontScale, options]);
}
